import React from 'react';
import { useLocation } from 'react-router-dom';

import { useAuth } from '../auth/AuthProviderUnified';
import DashboardSidebar from '../components/layout/DashboardSidebar';
import CommandBar from '../components/command-center/CommandBar/CommandBar';
import { useCommandBarNavigate } from '../components/command-center/CommandBar/useCommandBarNavigate';

// Path prefixes that render inside the persistent dashboard shell (sidebar + content).
// Public/auth/marketing pages are intentionally excluded.
export const SHELL_PREFIXES = [
  '/command-center', '/foreman', '/reports', '/workers', '/projects',
  '/schedule', '/analytics', '/assets', '/training', '/incidents',
  '/osha', '/admin', '/activity-log', '/ai-intelligence', '/planning',
  '/dashboard', '/equipment', '/worker-hours', '/learning-admin',
];

/**
 * AppShell — renders the persistent DashboardSidebar as a sibling of the routed
 * content, so it stays mounted across navigation (no flicker / scroll reset).
 * CommandBar (⌘K / Ctrl+K) mounts here for all authenticated dashboard routes.
 * Only shown when authenticated AND on a dashboard route; public pages render bare.
 */
export default function AppShell({ children }) {
  const location = useLocation();
  const { user } = useAuth();
  const onNavigate = useCommandBarNavigate();
  const path = location.pathname;
  const showSidebar =
    !!user && SHELL_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`));

  if (!showSidebar) return children;

  return (
    <div className="app-shell">
      <DashboardSidebar />
      <div className="app-main">{children}</div>
      <CommandBar onNavigate={onNavigate} />
    </div>
  );
}
